export default __webpack_public_path__ + "c679e9ce05dd8fda2d91f129ff13bc27.png";